import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=0386215b&lang=css"

const __exports__ = script;

export default __exports__